var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSphere(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 818 729"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "26.123%",
    cy: "37.366%",
    fx: "26.123%",
    fy: "37.366%",
    r: "62.861%",
    id: "sphere_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495D78",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101A2C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-14.6%",
    y: "-13.8%",
    width: "129.2%",
    height: "129.2%",
    filterUnits: "objectBoundingBox",
    id: "sphere_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.725490196 0 0 0 0 0.894117647 0 0 0 0 0.890196078 0 0 0 0.234320367 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "sphere_svg__b",
    cx: 1248,
    cy: 96,
    r: 528
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-622)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#sphere_svg__a)",
    xlinkHref: "#sphere_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#sphere_svg__c)",
    xlinkHref: "#sphere_svg__b"
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODE4cHgiIGhlaWdodD0iNzI5cHgiIHZpZXdCb3g9IjAgMCA4MTggNzI5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPk92YWwgQ29weSA3PC90aXRsZT4KICAgIDxkZWZzPgogICAgICAgIDxyYWRpYWxHcmFkaWVudCBjeD0iMjYuMTIyNTg3MSUiIGN5PSIzNy4zNjYxMTM1JSIgZng9IjI2LjEyMjU4NzElIiBmeT0iMzcuMzY2MTEzNSUiIHI9IjYyLjg2MDgyMjklIiBpZD0icmFkaWFsR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM0OTVENzgiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzEwMUEyQyIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9yYWRpYWxHcmFkaWVudD4KICAgICAgICA8Y2lyY2xlIGlkPSJwYXRoLTIiIGN4PSIxMjQ4IiBjeT0iOTYiIHI9IjUyOCI+PC9jaXJjbGU+CiAgICAgICAgPGZpbHRlciB4PSItMTQuNiUiIHk9Ii0xMy44JSIgd2lkdGg9IjEyOS4yJSIgaGVpZ2h0PSIxMjkuMiUiIGZpbHRlclVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgaWQ9ImZpbHRlci0zIj4KICAgICAgICAgICAgPGZlT2Zmc2V0IGR4PSIwIiBkeT0iOCIgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd09mZnNldE91dGVyMSI+PC9mZU9mZnNldD4KICAgICAgICAgICAgPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iNTAiIGluPSJzaGFkb3dPZmZzZXRPdXRlcjEiIHJlc3VsdD0ic2hhZG93Qmx1ck91dGVyMSI+PC9mZUdhdXNzaWFuQmx1cj4KICAgICAgICAgICAgPGZlQ29sb3JNYXRyaXggdmFsdWVzPSIwIDAgMCAwIDAuNzI1NDkwMTk2ICAgMCAwIDAgMCAwLjg5NDExNzY0NyAgIDAgMCAwIDAgMC44OTAxOTYwNzggIDAgMCAwIDAuMjM0MzIwMzY3IDAiIHR5cGU9Im1hdHJpeCIgaW49InNoYWRvd0JsdXJPdXRlcjEiPjwvZmVDb2xvck1hdHJpeD4KICAgICAgICA8L2ZpbHRlcj4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJPdmFsLUNvcHktNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYyMi4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgIDx1c2UgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMSIgZmlsdGVyPSJ1cmwoI2ZpbHRlci0zKSIgeGxpbms6aHJlZj0iI3BhdGgtMiI+PC91c2U+CiAgICAgICAgICAgIDx1c2UgZmlsbD0idXJsKCNyYWRpYWxHcmFkaWVudC0xKSIgZmlsbC1ydWxlPSJldmVub2RkIiB4bGluazpocmVmPSIjcGF0aC0yIj48L3VzZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgSphere as ReactComponent };